module.exports = __webpack_public_path__ + "static/01-f0e576c5c68dade8dfda51db8f0654e8.jpg";